<template>
    <ChildPage page-type="custom-page" />
</template>

<script setup lang="ts">
    import {useWebsitePageView} from '#imports';
    import ChildPage from '~/components/ChildPage.vue';

    useWebsitePageView('cms', 'landing');
</script>
